import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { smoothEnter, smoothLeave, smoothAfterEnter } from "@utils/Routing";
export default {
  data() {
    return {
      pinned: false,
      programFilter: "",
      entityFilter: "",
      transitionName: "slide-left",
      programId: null
    };
  },
  mounted() {
    this.loadProgramCategorySummary();
    if (this.entityProgramCategory && this.entityProgramCategory.Programs && this.entityProgramCategory.Programs.length) this.$store.dispatch("setProgramId", this.entityProgramCategory.Programs[0].ProgramId);
  },
  computed: {
    headerVisible() {
      return this.$store.getters["headerVisible"];
    },
    entity() {
      let aggregate = this.$store.state.entities.find(ent => ent.cycleId === this.$store.state.cycleId);
      if (!aggregate || !aggregate.entities) return {};
      let target = aggregate.entities.find(e => e.EntityId == this.$route.params.entityId);
      return target ? target : {};
    },
    entityProgramCategory() {
      let entityProgramCategory = this.$store.getters.entityProgramCategory;
      return entityProgramCategory ? entityProgramCategory : {};
    },
    entityProgramCategories() {
      return this.$store.state.entityProgramCategories.filter(ep => {
        let entityMatch = ep.EntityId == this.$route.params.entityId;
        if (this.programFilter.replace(" ", "").length > 0) return entityMatch && ep.ProgramName.toLowerCase().indexOf(this.programFilter.toLowerCase()) > -1;
        return entityMatch && ep.CycleId === this.$store.state.cycleId;
      }).sort((a, b) => {
        let p1 = a.Description.toLowerCase();
        let p2 = b.Description.toLowerCase();
        if (p1 < p2) return -1;
        if (p1 > p2) return 1;
        return 0;
      }).map(ep => {
        ep.active = this.$route.params.programCategoryId == ep.ProgramCategoryId;
        ep.url = `/institutions/${ep.EntityId}/programs/${ep.ProgramCategoryId}`;
        return ep;
      });
    },
    program() {
      let program = this.entityProgramCategory.Programs ? this.entityProgramCategory.Programs.find(pr => pr.ProgramId == this.$store.state.programId) : null;
      return program ? program : {};
    },
    programs() {
      let programs = this.$store.state.programs.filter(p => p.ProgramCategoryId == this.$route.params.programCategoryId);
      return programs ? programs : [{}];
    },
    programEntities() {
      return this.$store.state.entityProgramCategories.filter(ep => {
        let programMatch = ep.ProgramCategoryId == this.$route.params.programCategoryId;
        if (this.entityFilter.replace(" ", "").length > 0) return programMatch && ep.EntityName.toLowerCase().indexOf(this.entityFilter.toLowerCase()) > -1;
        return programMatch && ep.CycleId == this.$store.state.cycleId;
      }).sort((a, b) => {
        let p1 = a.EntityName.toLowerCase();
        let p2 = b.EntityName.toLowerCase();
        if (p1 < p2) return -1;
        if (p1 > p2) return 1;
        return 0;
      }).map(ep => {
        ep.active = this.$route.params.entityId == ep.EntityId;
        ep.url = `/institutions/${ep.EntityId}/programs/${ep.ProgramCategoryId}`;
        return ep;
      });
    }
  },
  watch: {
    $route(to, from) {
      if (to.params.entityId != from.params.entityId) {
        this.programId = null;
        this.$store.dispatch("setProgramId", 0);
      }
      let toParts = to.path + "";
      if (toParts.startsWith("/")) {
        toParts = toParts.substr(1, toParts.length - 1);
        toParts = toParts.split("/");
      }
      let fromParts = from.path + "";
      if (fromParts.startsWith("/")) {
        fromParts = fromParts.substr(1, fromParts.length - 1);
        fromParts = fromParts.split("/");
      }
      this.transitionName = toParts.length < fromParts.length ? "slide-right" : "slide-left";
    },
    entityProgramCategory(curr, prev) {
      if (curr && curr.Programs && curr.Programs.length && (prev == null || curr.ProgramCategoryId !== prev.ProgramCategoryId)) this.$store.dispatch("setProgramId", curr.Programs[0].ProgramId);
    },
    "$store.state.entityId"(curr, prev) {
      if (curr != null && prev != null && !this.$store.state.loading) this.loadProgramCategorySummary();
    },
    "$store.state.programId"(curr, prev) {
      if (curr != null && prev != null && !this.$store.state.loading) this.loadProgramCategorySummary();
    },
    "$store.state.cycleId"(curr, prev) {
      if (curr != null && prev != null) {
        this.loadProgramCategorySummary();
      }
    }
  },
  methods: {
    leave: smoothLeave,
    enter: smoothEnter,
    afterEnter: smoothAfterEnter,
    enterCancelled: smoothAfterEnter,
    updateParams(e, {
      entityId,
      programCategoryId
    }) {
      if (e && e.preventDefault) e.preventDefault();
      this.$router.push({
        name: this.$route.matched[1].name,
        params: {
          entityId: entityId ? entityId : this.$route.params.entityId,
          programCategoryId: programCategoryId ? programCategoryId : this.$route.params.programCategoryId
        },
        query: this.$route.query
      });
    },
    selectRef(key) {
      // delay ensure re-paint has occurred and ref is available for focus.
      setTimeout(() => this.$refs[key].select(), 1);
    },
    loadProgramCategorySummary() {
      this.$store.dispatch("loadProgramCategorySummary", {
        programCategoryId: this.$store.state.programCategoryId,
        entityId: this.$store.state.entityId,
        cycleId: this.$store.state.cycleId
      });
    }
  }
};